import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-left-back-fender',
    templateUrl: './question-damage-image-left-back-fender.component.html',
    styleUrls: ['./question-damage-image-left-back-fender.component.scss'],
    standalone: false
})
export class QuestionDamageImageLeftBackFenderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
